import React from 'react';
import { classNames } from '../tools/helpers';

export default function Logo({ children, className }) {
    return (
        <h1
            className={classNames(
                '!m-0 font-bold leading-8 text-[24px]',
                className,
            )}
        >
            Sara
            <span className={'font-normal'}>SweetHome</span>
            {children}
        </h1>
    );
}
